// Iconografia unica de la plataforma (estilo lineal, tipo Lucide/Heroicons).
// No mezclar otras librerias de iconos - ver Design System, seccion Iconografia.
import { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;
const base = (props: IconProps) => ({
  width: 22,
  height: 22,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  ...props,
});

export const HomeIcon = (p: IconProps) => (
  <svg {...base(p)}><path d="m3 11 9-8 9 8" /><path d="M5 10v10h14V10" /></svg>
);
export const TruckIcon = (p: IconProps) => (
  <svg {...base(p)}><rect x="1" y="6" width="14" height="11" rx="1" /><path d="M15 10h4l3 3v4h-7z" /><circle cx="6" cy="19" r="1.6" /><circle cx="17.5" cy="19" r="1.6" /></svg>
);
export const BoxIcon = (p: IconProps) => (
  <svg {...base(p)}><path d="m3.3 7 8.7 5 8.7-5" /><path d="M12 22V12" /><path d="m20.7 7-8.7 5-8.7-5 8.7-5 8.7 5Z" /></svg>
);
export const TimerIcon = (p: IconProps) => (
  <svg {...base(p)}><circle cx="12" cy="13" r="8" /><path d="M12 9v4l2.5 2.5" /><path d="M9 2h6" /></svg>
);
export const MoreIcon = (p: IconProps) => (
  <svg {...base(p)}><circle cx="5" cy="12" r="1.6" /><circle cx="12" cy="12" r="1.6" /><circle cx="19" cy="12" r="1.6" /></svg>
);
export const UsersIcon = (p: IconProps) => (
  <svg {...base(p)}><circle cx="9" cy="8" r="3.2" /><path d="M2.5 20c0-3.6 3-6 6.5-6s6.5 2.4 6.5 6" /><circle cx="17.5" cy="9" r="2.6" /><path d="M15 14.2c2.5.4 4.5 2.3 5 5.8" /></svg>
);
export const MapPinIcon = (p: IconProps) => (
  <svg {...base(p)}><path d="M12 22s7-6.2 7-12A7 7 0 0 0 5 10c0 5.8 7 12 7 12Z" /><circle cx="12" cy="10" r="2.6" /></svg>
);
export const DashboardIcon = (p: IconProps) => (
  <svg {...base(p)}><rect x="3" y="3" width="8" height="8" rx="1.5" /><rect x="13" y="3" width="8" height="5" rx="1.5" /><rect x="13" y="10" width="8" height="11" rx="1.5" /><rect x="3" y="13" width="8" height="8" rx="1.5" /></svg>
);
export const TrendIcon = (p: IconProps) => (
  <svg {...base(p)}><path d="M3 17 9 11l4 4 8-9" /><path d="M15 6h6v6" /></svg>
);
export const ReportIcon = (p: IconProps) => (
  <svg {...base(p)}><path d="M7 3h8l4 4v14H7z" /><path d="M15 3v4h4" /><path d="M9 13h6M9 17h6" /></svg>
);
export const SettingsIcon = (p: IconProps) => (
  <svg {...base(p)}><circle cx="12" cy="12" r="3.2" /><path d="M19.4 13.5a7.6 7.6 0 0 0 0-3l1.9-1.5-2-3.4-2.3.9a7.7 7.7 0 0 0-2.6-1.5L14 2.5h-4l-.4 2.5a7.7 7.7 0 0 0-2.6 1.5l-2.3-.9-2 3.4L4.6 10.5a7.6 7.6 0 0 0 0 3l-1.9 1.5 2 3.4 2.3-.9c.8.7 1.7 1.2 2.6 1.5l.4 2.5h4l.4-2.5c.9-.3 1.8-.8 2.6-1.5l2.3.9 2-3.4Z" /></svg>
);
export const HelpIcon = (p: IconProps) => (
  <svg {...base(p)}><circle cx="12" cy="12" r="9" /><path d="M9.5 9.3a2.5 2.5 0 0 1 4.9.7c0 1.7-2.4 1.8-2.4 3.5" /><path d="M12 17.5h.01" /></svg>
);
export const AuditIcon = (p: IconProps) => (
  <svg {...base(p)}><circle cx="10.5" cy="10.5" r="6.5" /><path d="M15.3 15.3 21 21" /><path d="M8 10.5h5" /></svg>
);
export const LogoutIcon = (p: IconProps) => (
  <svg {...base(p)}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="M16 17l5-5-5-5" /><path d="M21 12H9" /></svg>
);
export const PaletteIcon = (p: IconProps) => (
  <svg {...base(p)}><path d="M12 21a9 9 0 1 1 9-9c0 1.4-1.1 2.5-2.5 2.5H16a2 2 0 0 0-1.4 3.4c.3.3.4.7.4 1.1 0 1.1-1 2-2 2Z" /><circle cx="7.5" cy="10.5" r="1.2" /><circle cx="12" cy="7" r="1.2" /><circle cx="16.5" cy="10.5" r="1.2" /></svg>
);
export const PauseIcon = (p: IconProps) => (
  <svg {...base(p)}><rect x="6" y="5" width="4" height="14" rx="1" /><rect x="14" y="5" width="4" height="14" rx="1" /></svg>
);
export const PlayIcon = (p: IconProps) => (
  <svg {...base(p)}><path d="M7 4.5v15l13-7.5-13-7.5Z" /></svg>
);
export const EyeIcon = (p: IconProps) => (
  <svg {...base(p)}><path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" /><circle cx="12" cy="12" r="3" /></svg>
);
export const EyeOffIcon = (p: IconProps) => (
  <svg {...base(p)}><path d="M2.5 12S6 5.5 12 5.5c2 0 3.6.5 4.9 1.2M21.5 12S18 18.5 12 18.5c-2 0-3.6-.5-4.9-1.2" /><path d="M4 4l16 16" /><path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" /></svg>
);
export const PlusIcon = (p: IconProps) => (
  <svg {...base(p)}><path d="M12 5v14M5 12h14" /></svg>
);
export const FilterIcon = (p: IconProps) => (
  <svg {...base(p)}><path d="M4 5h16M7 12h10M10 19h4" /></svg>
);
export const EditIcon = (p: IconProps) => (
  <svg {...base(p)}><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" /></svg>
);
export const TrashIcon = (p: IconProps) => (
  <svg {...base(p)}><path d="M3 6h18" /><path d="M8 6V4h8v2" /><path d="M6 6l1 14h10l1-14" /></svg>
);
export const DownloadIcon = (p: IconProps) => (
  <svg {...base(p)}><path d="M12 3v12" /><path d="m7 10 5 5 5-5" /><path d="M5 21h14" /></svg>
);
export const DatabaseIcon = (p: IconProps) => (
  <svg {...base(p)}><ellipse cx="12" cy="5" rx="8" ry="3" /><path d="M4 5v14c0 1.66 3.58 3 8 3s8-1.34 8-3V5" /><path d="M4 12c0 1.66 3.58 3 8 3s8-1.34 8-3" /></svg>
);
export const CloseIcon = (p: IconProps) => (
  <svg {...base(p)}><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
);
export const ResetIcon = (p: IconProps) => (
  <svg {...base(p)}><path d="M21 12a9 9 0 1 1-3-6.7" /><path d="M21 3v6h-6" /></svg>
);
